import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchToken } from '../../app/helpers/fetch';
import { const_routes } from '../../app/helpers/const_routes';

const MODULE_KEYS = [
  'technology',
  'alternative',
  'experience',
  'innovation',
  'assistance',
  'financial',
  'vision',
  'regulation',
];

const AdminSemanticFieldsScreen = () => {
  const { t } = useTranslation();
  const [moduleKey, setModuleKey] = useState('technology');
  const [fields, setFields] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const resp = await fetchToken(
        const_routes.SCHEMA,
        const_routes.VERSIONV1,
        const_routes.ROUTE_SEMANTIC,
        `fields/${moduleKey}`
      );
      const body = await resp.json();
      if (!cancelled && body.ok) setFields(body.fields || []);
    };
    load().catch(console.error);
    return () => {
      cancelled = true;
    };
  }, [moduleKey]);

  return (
    <div className="container mt-4">
      <h2>{t('semanticSearch.fields.title', { defaultValue: 'Campos vectorizables' })}</h2>
      <p className="text-muted">
        {t('semanticSearch.fields.hint', {
          defaultValue: 'Parametrización activa en semantic_field_configs. El reproceso masivo se lanza en Jobs de vectorización.',
        })}
      </p>
      <div className="mb-3">
        <label className="form-label" htmlFor="semantic-fields-module">Módulo</label>
        <select
          id="semantic-fields-module"
          className="form-select"
          style={{ maxWidth: 280 }}
          value={moduleKey}
          onChange={(e) => setModuleKey(e.target.value)}
        >
          {MODULE_KEYS.map((key) => (
            <option key={key} value={key}>{t(`semanticSearch.module.${key}`)}</option>
          ))}
        </select>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-striped">
          <thead>
            <tr>
              <th>Prio</th>
              <th>Campo</th>
              <th>kind</th>
              <th>relation_as</th>
              <th>related</th>
              <th>max_words</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((row) => (
              <tr key={row.id}>
                <td>{row.priority}</td>
                <td><code>{row.field_name}</code></td>
                <td>{row.source_kind || 'column'}</td>
                <td>{row.relation_as || '—'}</td>
                <td>{row.related_field || '—'}</td>
                <td>{row.max_words == null ? 'NULL' : row.max_words}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminSemanticFieldsScreen;
